module.exports = __webpack_public_path__ + "static/media/yellowTheme-boy.24406705.svg";